import React, {Component} from 'react';
import { Select } from 'antd';

const { Option } = Select;

class FontFamilyTool extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value:'字体',
            options: [
                {key: '字体', val:'字体'},
                {key:'宋体', val:'宋体'},
                {key:'仿宋_gb2312', val:'仿宋_gb2312'},
                {key:'楷体', val:'楷体'},
                {key:'微软雅黑', val:'微软雅黑'},
                {key:'黑体', val:'黑体'},
                {key:'隶书', val:'隶书'},
                {key:'andale mono', val:'andale mono'},
                {key:'arial black', val:'arial black'},
                {key:'comic sans ms', val:'comic sans ms'},
                {key:'impact', val:'impact'},
                {key:'times new roman', val:'times new roman'},

            ]
        }
    }
    render() {
        return (
            <span>
                <Select size={"small"} value={this.state.value} style={{width:this.props.width}} dropdownMatchSelectWidth={false} dropdownClassName={'fontFamilySelect'}
                        onChange={(e)=>{
                            this.setState({value:e});
                            this.props.editor.execCommand( 'fontfamily', e )
                        }}>

                {this.state.options.map(item=>{
                    if(item.key === "字体") {
                        return ""
                    }
                    return <Option key={item.key} value={item.key} style={{fontFamily:item.key}}>{item.val}</Option>
                })}
            </Select>
                <style>
                    {`.fontFamilySelect .ant-select-dropdown-menu-item {padding: 2px 12px}` }
                </style>
            </span>
        );
    }

    /**
     * 监听内容变化
     */
    listenContentChange(){
        let ulKey = this.props.editor.queryCommandValue("fontfamily");
        this.setState({value:ulKey.replace(/\"/g, "")});
    }

    /**
     * 监听编辑器点击
     */
    listenContentClick(){
        let ulKey = this.props.editor.queryCommandValue("fontfamily");
        this.setState({value:ulKey.replace(/\"/g, "")});
    }
}

export default FontFamilyTool;